import React from "react";
import { ArrowUpRight, GraduationCap } from "lucide-react";
import { OZENTYA_FORMATION_URL } from "@/lib/social";

export const FormationTeaser = () => (
  <section
    id="formation"
    data-testid="home-formation"
    className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-12 md:py-16"
  >
    <div className="rounded-3xl bg-[var(--oz-dark)] text-white px-6 py-10 sm:px-12 sm:py-14 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2 mb-3">
          <GraduationCap className="w-5 h-5 text-[var(--oz-gold)]" />
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--oz-gold)]">
            Formation
          </span>
        </div>
        <h2 className="font-serif text-3xl sm:text-4xl leading-tight">Se former avec Ozentya</h2>
        <p className="mt-3 text-base text-white/75">
          Découvrez nos formations pour maîtriser les produits, conseiller vos clientes et
          développer votre activité en toute confiance.
        </p>
      </div>
      <a
        href={OZENTYA_FORMATION_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="home-formation-link"
        className="group inline-flex items-center justify-center gap-2 rounded-full bg-[var(--oz-gold)] text-[var(--oz-dark)] font-semibold px-7 py-4 min-h-[48px] flex-shrink-0 transition-transform hover:-translate-y-0.5"
      >
        Découvrir ozentyaformation.com
        <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    </div>
  </section>
);
